// Copyright © 2025 CATTLEytics Inc.

import 'react-virtualized/styles.css';

import React from 'react';

import Page from '../../common/components/Page';
import { DynamicQuery } from './DynamicQuery';
import { EventsByMonthPivot } from './EventsByMonthPivot';
import { MonthlyTerminationsPivot } from './MonthlyTerminationsPivot';
import { PivotQuery } from './PivotQuery';
import { SoldAnimalsPivot } from './SoldAnimalsPivot';

interface Props {
  className?: string;
}

/**
 * Routable component to display source reports.
 *
 * From JEFO Superset Dashboard.
 */
export const ReportsSourceData = (props: React.PropsWithChildren<Props>): JSX.Element => {
  return (
    <Page
      breadcrumbTitle={'Source Data'}
      breadcrumbs={[
        { label: 'Reports', to: '/' },
        { label: 'Source', to: '/' },
      ]}
      className={props.className}
      title={'Source Data'}
    >
      <DynamicQuery reportName={'Herd Milk'} />
      <PivotQuery reportName={'Events By Month'}>
        {({ data }): JSX.Element => <EventsByMonthPivot data={data} />}
      </PivotQuery>
      <PivotQuery reportName={'Sold Animals'}>
        {({ data }): JSX.Element => <SoldAnimalsPivot data={data} />}
      </PivotQuery>
      <PivotQuery reportName={'Monthly Terminations'}>
        {({ data }): JSX.Element => <MonthlyTerminationsPivot data={data} />}
      </PivotQuery>

      <DynamicQuery reportName={'Animals'} />
      <DynamicQuery reportName={'Milk Test Day Properties'} />
      <DynamicQuery reportName={'Lactation'} />
      <DynamicQuery reportName={'Bred Outcomes'} />
      <DynamicQuery reportName={'Terminations'} />
    </Page>
  );
};
